<div class="service-order-shell">
    <div class="container fw-b wrapper-content">
        <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
    </div>

    <!-- Radio Group for Service Type Selection (only for non-ALL roles) -->
    <section class="container service-type-selector" *ngIf="serviceRole != 'ALL'">
        <div class="radio-group-container">
            <div class="radio-group">
                <input type="radio" [checked]="getEndUrlSegment() == 'service-order-detail'" name="del"
                    (change)="setUrl('service-order-detail')" id="standard">
                <label for="standard">Standard Services</label>
            </div>
            <div class="radio-group">
                <input type="radio" [checked]="getEndUrlSegment() == 'assigned-service-pickup'" name="del"
                    (change)="setUrl('assigned-service-pickup')" id="pickup">
                <label for="pickup">Transportation Services</label>
            </div>
            <div class="radio-group">
                <input type="radio" [checked]="getEndUrlSegment() == 'assigned-service-field'" name="del"
                    (change)="setUrl('assigned-service-field')" id="field">
                <label for="field">Fulfilment Services</label>
            </div>
        </div>
    </section>

    <!-- Hero Section (aligned with Transaction History layout) -->
    <section class="container transaction-hero" *ngIf="!isRejected || serviceRole != 'ALL'">
        <div class="hero-container-card">
            <div class="hero-cards-wrapper">
                <div class="hero-stat-card wallet-card">
                    <div class="card-accent-strip wallet-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper wallet-icon">
                            <i class="fa fa-list-ul" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">
                            {{ count || 0 }}
                        </p>
                        <label class="stat-label">ORDERS IN VIEW</label>
                    </div>
                </div>
                <div class="hero-stat-card earning-card">
                    <div class="card-accent-strip earning-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper earning-icon">
                            <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">
                            {{ btn == 'Pending' ? 'Pending Orders' : 'Completed Orders' }}
                        </p>
                        <label class="stat-label">CURRENT VIEW</label>
            </div>
                </div>
                <div class="hero-stat-card commission-card">
                    <div class="card-accent-strip commission-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper commission-icon">
                            <i class="fa fa-user" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">
                            {{ serviceRole || 'SERVICE' }}
                        </p>
                        <label class="stat-label">SERVICE ROLE</label>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Tabs -->
    <section class="container order-tabs" *ngIf="!isRejected || serviceRole != 'ALL'">
        <div class="row g-3">
            <div class="col-sm-6">
                <button class="tabBtn" [ngClass]="{active : btn == 'Pending'}" (click)="selectBtn('Pending')">
                    <span>Pending</span>
                </button>
            </div>
            <div class="col-sm-6">
                <button class="tabBtn" [ngClass]="{active : btn == 'Complete'}" (click)="selectBtn('Complete')">
                    <span>Completed</span>
                </button>
            </div>
        </div>
    </section>

    <section class="container table-wrapper">
        <!-- SERVICE Role Table -->
        <article class="order-table-card" *ngIf="serviceRole == 'SERVICE'">
            <div class="table-header">
                <div>
                    <p class="section-eyebrow">{{ btn == 'Pending' ? 'Pending Orders' : 'Completed Orders' }}</p>
                    <h2>{{ btn == 'Pending' ? 'Orders awaiting action' : 'Completed & fulfilled' }}</h2>
                </div>
                <span class="badge-counter">{{ count || 0 }} orders</span>
            </div>

            <div class="table-responsive">
                <table class="table modern-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Customer Name</th>
                            <th>Service Id</th>
                            <th>Booked At</th>
                            <th>Service Date</th>
                            <th>Category</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index;">
                            <td data-label="S.No">{{ pageSize * (currentPage - 1) + i + 1 }}</td>
                            <td data-label="Customer Name">{{ item?.userId?.firstName }} {{ item?.userId?.lastName }}</td>
                            <td data-label="Service Id">{{ item?.orderId }}</td>
                            <td data-label="Booked At">{{ formatBookedDateTime(item?.createdAt) }}</td>
                            <td data-label="Service Date">{{ formatServiceDateTime(item?.duration, item?.slots[0]) }}</td>
                            <td data-label="Category">{{ item?.myOrders[0]?.serviceId?.categoryId?.categoryName }}</td>
                            <td data-label="Order Status">
                                <span class="status-chip" [ngClass]="getServiceStatusClass(item?.serviceStatus || item?.orderStatus)">
                                    {{ formatServiceStatus(item?.serviceStatus || item?.orderStatus) }}
                                </span>
                            </td>
                            <td data-label="Payment Status">
                                <span class="status-chip" [ngClass]="getPaymentStatusClass(item?.paymentStatus)">
                                    {{ item?.paymentStatus || '--' }}
                                </span>
                            </td>
                            <td class="text-center" data-label="Action">
                                <button class="ghost-link"
                                    [queryParams]="{_id: item?._id, status: item?.orderStatus}"
                                    [routerLink]="['/service-order-detail-view']">
                                    View
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <app-table-loader [isTable]="'TABLE'" [isLoading]="isLoading" [notFoundData]="notFoundData"
                [colspan]="9" [isWidth]="'80px'"></app-table-loader>
            <div class="transaction-table-footer" *ngIf="count > pageSize">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </article>

        <!-- TRANS/FIELD/DELIVERY/ALL Role Table -->
        <article class="order-table-card" *ngIf="serviceRole == 'TRANS' || serviceRole == 'FIELD' || serviceRole == 'DELIVERY' || serviceRole == 'ALL'">
            <div class="table-header">
                <div>
                    <p class="section-eyebrow">{{ btn == 'Pending' ? 'Pending Orders' : 'Completed Orders' }}</p>
                    <h2>{{ btn == 'Pending' ? 'Orders awaiting action' : 'Completed & fulfilled' }}</h2>
                </div>
                <span class="badge-counter">{{ count || 0 }} orders</span>
            </div>

            <div class="table-responsive">
                <table class="table modern-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Order Id</th>
                            <th *ngIf="serviceRole == 'TRANS'">Retailer Name</th>
                            <th *ngIf="serviceRole == 'TRANS' || serviceRole == 'FIELD'">Customer Name</th>
                            <th *ngIf="serviceRole == 'TRANS' || serviceRole == 'FIELD'">Customer Email</th>
                            <th>Total Amount</th>
                            <th>Quantity</th>
                            <th>Delivery Type</th>
                            <th>Order Date</th>
                            <th>Order Status</th>
                            <th>Role</th>
                            <th class="text-center" *ngIf="!isRejected">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of pickupOrderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index;">
                            <td data-label="S.No">{{ pageSize * (currentPage - 1) + i + 1 }}</td>
                            <td data-label="Order Id">{{ item?.orderId?.orderId }}</td>
                            <td *ngIf="serviceRole == 'TRANS'" data-label="Retailer Name">
                                {{ item?.orderId?.productDetails[0]?.productId?.userId?.firstName + " " + item?.orderId?.productDetails[0]?.productId?.userId?.lastName || '--' }}
                            </td>
                            <td *ngIf="serviceRole == 'TRANS' || serviceRole == 'FIELD'" data-label="Customer Name">
                                {{ item?.orderId?.userId?.firstName + " " + item?.orderId?.userId?.lastName || '--' }}
                            </td>
                            <td *ngIf="serviceRole == 'TRANS' || serviceRole == 'FIELD'" data-label="Customer Email">
                                {{ item?.orderId?.userId?.email || '--' }}
                            </td>
                            <td data-label="Total Amount" class="amount-cell">
                                {{ item?.orderId?.orderPrice ? getPrice(item?.orderId?.orderPrice | currency:"ZAR":"R") : "--" }}
                            </td>
                            <td data-label="Quantity">{{ getNoOfquantity(item?.orderId?.productDetails) }}</td>
                            <td data-label="Delivery Type">{{ getDeliveryName(item?.orderId?.deliveryType) }}</td>
                            <td data-label="Order Date">{{ formatBookedDateTime(item?.createdAt) }}</td>
                            <td data-label="Order Status">
                                <span class="status-chip" [ngClass]="getServiceStatusClass(item?.requestStatus)">
                                    {{ formatServiceStatus(item?.requestStatus == 'ONTHEWAY' ? 'ONTHEWAY' : item?.requestStatus) }}
                                </span>
                            </td>
                            <td data-label="Role">{{ getRole(item?.userType) || '--' }}</td>
                            <td *ngIf="!isRejected" class="text-center" data-label="Action">
                                <button class="ghost-link"
                                    [queryParams]="{_id: item?._id, status: item?.orderStatus, type: btn}"
                                    [routerLink]="['/service-order-detail-view']">
                                    View
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <app-table-loader [isTable]="'TABLE'" [isLoading]="isLoading" [notFoundData]="notFoundData"
                [colspan]="11" [isWidth]="'80px'"></app-table-loader>
            <div class="transaction-table-footer" *ngIf="count > pageSize">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </article>
    </section>
</div>
<select-service-type *ngIf="showService" [serviceList]="serviceList"></select-service-type>
